import {
  FOOTBALL_PLAY_PRO_ONBOARDING_CLUB_SELECTION,
  FOOTBALL_PLAY_PRO_ONBOARDING_SELECT_COMPETITION,
} from 'constants/__generated__/routes';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { OnboardingFlow } from 'lib/onboardingFlow';

export const useGetSelectClubPath = () => {
  const { currentUser } = useCurrentUserContext();
  const {
    flags: { useNewFootballCommonGameOnboarding = false },
  } = useFeatureFlags();

  if (
    currentUser?.onboardingFlow === OnboardingFlow.COMMON_GAME &&
    useNewFootballCommonGameOnboarding
  ) {
    return FOOTBALL_PLAY_PRO_ONBOARDING_SELECT_COMPETITION;
  }

  return FOOTBALL_PLAY_PRO_ONBOARDING_CLUB_SELECTION;
};
